/*
 * Copyright (c) 2018 teamapps.org (see code comments for author's name)
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * THIS IS GENERATED CODE!
 * PLEASE DO NOT MODIFY - ALL YOUR WORK WOULD BE LOST!
 *
 * @author	Yann Massard, yamass@gmail.com
 * @author	Matthias Bernstein, matthias.bernstein@data-centrics.com
 */
export const typescriptDeclarationFixConstant = 1;

import {UiEvent} from "./UiEvent";
import {UiCommand} from "./UiCommand";
import {UiSubEvent} from "./UiSubEvent";
import {UiSubCommand} from "./UiSubCommand";
import {TeamAppsEvent} from "../modules/util/TeamAppsEvent";
import {UiPanelConfig} from "./UiPanelConfig";
import {UiColorConfig} from "./UiColorConfig";
import {UiPanelCommandHandler} from "./UiPanelConfig";
import {UiPanelEventSource} from "./UiPanelConfig";


export interface UiWindowConfig extends UiPanelConfig {
	_type?: string;
	modal?: boolean;
	width?: number;
	height?: number;
	headerBackgroundColor?: UiColorConfig;
	modalBackgroundDimmingColor?: UiColorConfig;
	closeable?: boolean;
	closeOnEscape?: boolean;
	closeOnClickOutside?: boolean
}

export interface UiWindowCommandHandler extends UiPanelCommandHandler {
	close(animationDuration: number): void;
	setCloseable(closeable: boolean): void;
	setCloseOnEscape(closeOnEscape: boolean): void;
	setCloseOnClickOutside(closeOnClickOutside: boolean): void;
	setModal(modal: boolean): void;
	setModalBackgroundDimmingColor(modalBackgroundDimmingColor: UiColorConfig): void;
	setSize(width: number, height: number): void;
}

export interface UiWindowEventSource extends UiPanelEventSource {
}

